import React from 'react';


export const RoomActionsContext = React.createContext('');

export const SupportLinksContext = React.createContext('');

export const UserActionsContext = React.createContext('');
